new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {

    }
})

$(document).ready(function () {
    const footerSection = document.querySelectorAll('#footer .footer-section');
    if (footerSection.length) {
        footerSection.forEach((item) => {
            let footerContent = item.querySelector('.footer-section-content');
            item.addEventListener('click', () => {
                item.classList.toggle('active');
                footerContent.classList.toggle('active');
            })
        });
    }
});